import React from "react";
import {useAuthStore} from "../../store/authStore";

function Account() {
    const user = useAuthStore((state) => state.user);
    const logout = useAuthStore((state) => state.logout);

    return (
        <div className="container py-5" style={{maxWidth: '480px'}}>
            {user ? (
                <div>
                    <h1 className="text-2xl font-semibold leading-tight text-blue-800 mb-4">Your account</h1>
                    <p className="mb-1"><span className="text-gray-400">Display name:</span> {user.displayName}</p>
                    <p className="mb-4"><span className="text-gray-400">Email:</span> {user.email}</p>
                    <button type="button" className="btn" onClick={logout}>Log out</button>
                </div>
            ) : (
                <div>
                    <h1 className="text-2xl font-semibold leading-tight text-blue-800 mb-4">You're not logged in</h1>
                    <p className="mb-4 text-gray-600">
                        You can browse and comment on this site anonymously. Log in or create an account
                        to comment under your name and manage your comments.
                    </p>
                    <a href="/login" className="btn mr-2">Log in</a>
                    <a href="/register" className="btn">Register</a>
                </div>
            )}
        </div>
    );
}

export default Account;
